import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import RenderInView from 'components/RenderInView'
import { REGION_JP } from 'constants/regions'
import { LocalizationContext } from 'contexts/Localization'
import { ResizeContext } from 'contexts/Resize'
import { biomeNutrition } from 'routes'
import { US } from 'constants/countries'
import { Button } from 'shared/Button'

import {
  Wrapper,
  IconWrapper,
  Center,
  ImageWrapper,
  DynamicImageStyled,
} from './styles'

const chart_version = REGION_JP === process.env.region ? '150921' : '1'

const BAboutSubscriptionInner = ({ pathCdn, pathShared }) => {
  const { dict, locale } = React.useContext(LocalizationContext)
  const { tablet, mobile } = React.useContext(ResizeContext)

  const isUS = locale === US
  const imageExt = isUS ? 'png' : 'svg'

  return (
    <RenderInView display='block'>
      <Wrapper>
        <DynamicImageStyled
          alt='Ipad'
          imageSizes={{
            md: 1305,
          }}
          image={`${pathShared}/ipad_full`}
          fitOption='none'
          imageType='png'
        />

        <ImageWrapper isUS={isUS}>
          {!tablet && !mobile && (
            <img
              width='auto'
              height='100%'
              src={`${pathCdn}/chart_about_${chart_version}.${imageExt}`}
              alt='chart'
            />
          )}
          {tablet && (
            <img
              width='auto'
              height='100%'
              src={`${pathCdn}/chart_about_${chart_version}_tablet.${imageExt}`}
              alt='chart tablet'
            />
          )}
          {mobile && (
            <img
              width='auto'
              height='100%'
              src={`${pathCdn}/chart_about_${chart_version}_mob.${imageExt}`}
              alt='chart mobile'
            />
          )}
        </ImageWrapper>

        {!isUS && (
          <IconWrapper>
            <Icon id='color_bacteria_hello' />
          </IconWrapper>
        )}
      </Wrapper>

      {mobile && (
        <Center>
          <Button
            href={biomeNutrition.as(locale)}
          >
            {dict.buttons.learn_more}
          </Button>
        </Center>
      )}
    </RenderInView>
  )
}

BAboutSubscriptionInner.propTypes = {
  pathCdn: PropTypes.string.isRequired,
  pathShared: PropTypes.string.isRequired,
}

export default BAboutSubscriptionInner
